import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" data-testid="cookie-banner">
      <div className="cookie-inner">
        <p className="cookie-text">
          Wir verwenden Cookies, um Ihnen die bestmögliche Nutzung unserer Website zu ermöglichen.
          Technisch notwendige Cookies werden für die Grundfunktionen der Website benötigt.
          Weitere Informationen finden Sie in unserer{' '}
          <Link to="/datenschutz" className="cookie-link">Datenschutzerklärung</Link>.
        </p>
        <div className="cookie-actions">
          <button onClick={decline} className="cookie-btn-decline" data-testid="cookie-decline-btn">
            Nur notwendige
          </button>
          <button onClick={accept} className="cookie-btn-accept" data-testid="cookie-accept-btn">
            Alle akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
}
